import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { TherapistStackParamList } from '@/navigations/TherapistStack';
import { SetEditorFlow } from '@/contexts/SetEditorContext';

const CANCEL_TARGET: Record<SetEditorFlow, 'PatientProfile' | 'TemplateList'> =
  {
    createSet: 'PatientProfile',
    editSet: 'PatientProfile',
    templateFromSet: 'PatientProfile',
    createTemplate: 'TemplateList',
    editTemplate: 'TemplateList',
    duplicateTemplate: 'TemplateList',
  };

export function useSetEditorCancel(flow: SetEditorFlow, patientId?: string) {
  const navigation =
    useNavigation<StackNavigationProp<TherapistStackParamList>>();

  return useCallback(() => {
    if (CANCEL_TARGET[flow] === 'TemplateList') {
      navigation.navigate('TemplateList');
      return;
    }
    navigation.navigate({
      name: 'PatientProfile',
      params: { id: patientId ?? '' },
      merge: true,
    });
  }, [navigation, flow, patientId]);
}
